import { Key } from './types';

type CacheTime = Record<
  Key,
  {
    minutes: number;
    shouldDeleteOnUserSignOut: boolean;
  }
>;

export const cacheTime: CacheTime = {
  token: {
    minutes: 0,
    shouldDeleteOnUserSignOut: true,
  },
  refreshToken: {
    minutes: 0,
    shouldDeleteOnUserSignOut: true,
  },
  isLogged: {
    minutes: 0,
    shouldDeleteOnUserSignOut: true,
  },
  userId: {
    minutes: 0,
    shouldDeleteOnUserSignOut: true,
  },
  verifier: {
    minutes: 10,
    shouldDeleteOnUserSignOut: true,
  },
  activeCompanyPhoneNumber: {
    minutes: 0,
    shouldDeleteOnUserSignOut: true,
  },
  lastBulkJobId: {
    minutes: 60 * 24,
    shouldDeleteOnUserSignOut: false,
  },
};
